import { useCallback } from "react";

import { Card } from "../../../components/Card";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { Flex, Stack } from "@chakra-ui/react";
import { Input } from "../../../components/Form/Input";
import { api } from "../../../services/api";
import { BackButton } from "../../../components/atoms/Button/BackButton";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../hooks/toast";
import { SubmitButton } from "../../../components/atoms/Button/SubmitButton";

type FranchiseFormData = {
  name: string;
  radical?: string;
};

const createFranchiseFormSchema = yup.object().shape({
  name: yup
    .string()
    .required("Nome obrigatório")
    .min(3, "O nome deve conter no mínimo 3 caracteres"),
});

export function CreateFranchise() {
  const navigate = useNavigate();
  const toast = useToast();
  const { register, handleSubmit, formState } = useForm<FranchiseFormData>({
    resolver: yupResolver(createFranchiseFormSchema),
  });

  const handleCreateFranchise: SubmitHandler<FieldValues> = useCallback(
    async (formValue) => {
      try {
        await api.post("/franchises", {
          name: formValue.name,
          radical: formValue.radical,
        });
        navigate("/redes");
        toast({
          title: "Rede cadastrada com sucesso!",
          status: "success",
        });
      } catch {
        toast({
          title: "Não foi possível cadastrar a rede",
          status: "error",
        });
      }
    },
    [navigate, toast]
  );
  const { errors } = formState;

  return (
    <>
      <Card
        border="#216ca5"
        title="Cadastrar Rede"
        header={<BackButton onClick={() => navigate(-1)} />}
        body={
          <Flex
            as="form"
            flexDir="column"
            w="100%"
            onSubmit={handleSubmit(handleCreateFranchise)}
            id="add-form"
          >
            <Stack spacing="4" mb="4">
              <Input
                type="text"
                label="Nome"
                isRequired={true}
                error={errors.name}
                {...register("name")}
              />
              <Input
                type="text"
                label="Radical"
                isRequired={false}
                error={errors.radical}
                {...register("radical")}
              />
            </Stack>
          </Flex>
        }
        footer={<SubmitButton formState={formState} />}
      />
    </>
  );
}
